import { ServiceClientAction } from '/state/service/appTs/types';
import { ServiceStateStrict } from 'state/service/app';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { update } from './tmClient';
import defaultAppState from 'defaultAppState';

/**
 * Used in devlopment as we migrate Elm over to TypeScript.
 *
 * Run the following command to run tests and generate coverrage on the fly:
 * pnpm test_jest_coverage test/state/serviceActions/ --watch
 */
export default function serviceClient(
  state: ServiceStateStrict = defaultAppState,
  action: ServiceClientAction
): ServiceStateStrict {
  switch (action.type) {
    case 'SERVICE_CLIENT_SERVER_BASE_URL':
      return state; // TODO
    case 'SERVICE_CLIENT_INBOUND_MESSAGE_ACKNOWLEDGEMENT':
      return state; // TODO
    case 'SERVICE_CLIENT_INITIAL_APP_STATE':
      return update(state, { type: 'InitAppState', initialModel: action.payload });
    case 'SERVICE_CLIENT_REQUEST_CURRENT_MODEL':
      return update(state, { type: 'SendModel' });
    case 'SERVICE_CLIENT_SET_HISTORY_TOGGLED_ON':
      return update(state, { type: 'SetHistoryToggledOn', toggledOn: action.payload });
    case 'SERVICE_CLIENT_SET_IS_READ_ONLY':
      return update(state, { type: 'SetIsReadOnly', isReadOnly: action.payload });
    case 'SERVICE_CLIENT_DISPLAY_ERROR':
      return update(state, { type: 'DisplayError', message: action.payload });
    case 'SERVICE_CLIENT_MARK_HISTORY_ITEMS_AS_READ':
      return update(state, { type: 'MarkHistoryItemsAsRead' });
    case 'SERVICE_CLIENT_SEND_CHAT_MESSAGE':
      return update(state, { type: 'SendChat', timestampSecs: 0, chatMessage: '' }); // TODO timestamp and chatmessage
    case 'SERVICE_CLIENT_SET_TOPIC':
      return update(state, { type: 'SetTopic', topicChangeRequest: action.payload });
    case 'SERVICE_CLIENT_CLEAR_ERROR':
      return update(state, { type: 'ClearError' });
    case 'SERVICE_CLIENT_RECEIVE_HISTORY':
      return update(state, { type: 'LoadHistory', messagesAndDate: action.payload });
    case 'SERVICE_CLIENT_FETCH_MORE_HISTORY':
      return update(state, { type: 'FetchMoreHistory' });
    case 'SERVICE_CLIENT_FETCH_HISTORY_FAILED':
      return update(state, { type: 'FetchHistoryFailed' });
    case 'SERVICE_CLIENT_SET_HISTORY_LATEST_EVENT_ID':
      return state; //todo
    default:
      // istanbul ignore next
      return assertNever(action);
  }
}
